(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/helpers/handlebar-helper.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/helpers/handlebar-helper.js');

'use strict';

const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
function registerHelpers(hbs) {
  hbs.registerHelper('score', score => score.replace('-', ' - '));
  hbs.registerHelper('fancyUrl', (team1, team2) => {
    if (team1 && team2) {
      return "".concat(team1.replace(' ', '-').toLowerCase(), "-").concat(team2.replace(' ', '-').toLowerCase());
    }
    return '';
  });
  hbs.registerHelper('doubleWinAmount', function (drawNumber, product, options) {
    return product === 'stryktipset' && (drawNumber === 4580 || drawNumber === 4581) ? options.fn(this) : options.inverse(this);
  });
  let lastDate;
  hbs.registerHelper('setDay', (resIndex, matchStartTime) => {
    let resultString = '';
    let newDateBar = false;
    let matchStartTimeToShow = '';
    let matchStartTimeData = '';
    if (resIndex === 0) {
      lastDate = '';
    }
    if (matchStartTime) {
      matchStartTimeToShow = formatDate(new Date(matchStartTime), false, true, true);
      matchStartTimeData = dateFns.format(new Date(matchStartTime), 'yyyy-MM-dd', {
        locale: dateFns.locales.sv
      });
      newDateBar = matchStartTimeToShow !== lastDate;
      lastDate = matchStartTimeToShow;
    }
    if (newDateBar) {
      resultString = "<div class=\"game-result-oddset-day-devider\" id=".concat(matchStartTimeData, ">").concat(matchStartTimeToShow.charAt(0).toUpperCase()).concat(matchStartTimeToShow.substring(1), "</div>");
    }
    return new Handlebars.SafeString(resultString);
  });
  hbs.registerHelper('teamNamesHelper', result => {
    let resultString = '';
    const teamNames = result.description;
    if (teamNames.length < 26) {
      resultString += "<div class=\"padding-xs-v-1 padding-xs-left-1 f-100\">".concat(teamNames, "</div>");
      return new Handlebars.SafeString(resultString);
    }
    const teamNamesList = teamNames.split('-');
    if (teamNamesList.length === 2) {
      resultString += "<div class=\"game-results-two-line-teams padding-xs-left-1 f-100\">".concat(teamNamesList[0], "-<br />").concat(teamNamesList[1], "</div>");
    } else {
      resultString += "<div class=\"padding-xs-v-1 padding-xs-left-1 game-results-oddset-outcome-big-odds\">".concat(teamNames, "</div>");
    }
    return new Handlebars.SafeString(resultString);
  });
  hbs.registerHelper('concat', function () {
    const args = Array.prototype.slice.call(arguments);
    let concatString = '';
    for (let i = 0; i < args.length - 1; i++) {
      concatString += args[i];
    }
    return concatString;
  });
  hbs.registerHelper('formatStartTime', startTime => formatDate(new Date(startTime), true, true, true, true));
  hbs.registerHelper('getWinGroup', (winGroup, product) => {
    let returnValue;
    let startValue;
    if (product === 'challenge' || product === 'bomben') {
      returnValue = 'Alla rätt';
    } else {
      startValue = product === 'stryktipset' || product === 'europatipset' || product === 'extratipset' ? 14 : 9;
      returnValue = "".concat(startValue - winGroup, " r\xE4tt");
    }
    return returnValue;
  });
  hbs.registerHelper('formatWinValue', (product, winValue) => {
    if (product === 'powerplay' || product === 'challenge' || product === 'bomben') {
      if (winValue === '0,00') {
        return 'Rullpott';
      }
      return "Odds: ".concat(svs.utils.format.Odds(winValue));
    }
    return "".concat(svs.utils.format.Currency(winValue), " kr");
  });
  hbs.registerHelper('formatOutcome', (outcome, outcomes, product, cancelled) => {
    if (product === 'bomben' || !outcome || cancelled && product === 'challenge') {
      return '';
    }
    let returnValue = '';
    if (product === 'challenge') {
      let matchingOutcome;
      switch (outcome) {
        case '1':
          matchingOutcome = _.find(outcomes, outcome => outcome.outcomeNumber === 1);
          break;
        case 'X':
          matchingOutcome = _.find(outcomes, outcome => outcome.outcomeNumber === 2);
          break;
        case '2':
          matchingOutcome = _.find(outcomes, outcome => outcome.outcomeNumber === 4);
          break;
        default:
      }
      returnValue = matchingOutcome && matchingOutcome.description ? matchingOutcome.description : outcome;
      if (returnValue.toLowerCase().indexOf('over') !== -1 || returnValue.toLowerCase().indexOf('över') !== -1) {
        returnValue = 'Ö';
      }
      if (returnValue.toLowerCase().indexOf('under') !== -1) {
        returnValue = 'U';
      }
    } else {
      returnValue = outcome;
    }
    return returnValue;
  });
  hbs.registerHelper('matchWinner', (outcome, state) => {
    let winner;
    if (state == 1) {
      winner = '';
    } else {
      switch (outcome) {
        case '1':
          winner = 'home-win';
          break;
        case '2':
          winner = 'away-win';
          break;
        case 'X':
          winner = 'tie';
          break;
        default:
          winner = '';
      }
    }
    return new hbs.SafeString(winner);
  });
  hbs.registerHelper('matchIsLive', matchState => {
    let returnValue;
    switch (matchState) {
      case 1:
        returnValue = 'game-results-match-is-live';
        break;
      default:
        returnValue = '';
    }
    return new hbs.SafeString(returnValue);
  });
  hbs.registerHelper('latestChanges', latestUpdate => {
    let returnValue = '';
    switch (latestUpdate) {
      case 'home':
        returnValue += 'latest-change home-scored';
        break;
      case 'away':
        returnValue += 'latest-change away-scored';
        break;
      case 'both':
        returnValue += 'latest-change';
        break;
      default:
    }
    return new hbs.SafeString(returnValue);
  });
  hbs.registerHelper('showTrottingForecast', function (isTrotting, options) {
    if (isTrotting) {
      return options.fn(this);
    }
    return options.inverse(this);
  });
  hbs.registerHelper('checkVerifiedResults', function (verifiedEvents, drawState, options) {
    if (verifiedEvents || drawState === svs.game_results.constants.drawStates.FINALIZED) {
      return options.fn(this);
    }
    return options.inverse(this);
  });
}
registerHelpers(Handlebars);

 })(window);